<script setup lang="ts">
import ButtonsQty from '@/components/SizeAndButtons/QtyPopup/Buttons.vue'
import StitchesQty from '@/components/SizeAndButtons/QtyPopup/Stitches.vue'
import StitchesType from '@/components/SizeAndButtons/QtyPopup/StitchesType.vue'
import StitchesTypeSingle from '@/components/SizeAndButtons/Popup/StitchesType.vue'
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'
import { IconInfo } from '@/components/icons'

const store = useStore()
const { isStitches, isButtons } = storeToRefs(store)

function unsetStitchesData() {
  store.stitchesDistribution = ''
  store.stitchesCols = ''
  store.stitchesRows = ''
  store.stitchesDistanceToEdge = ''
  store.topStitchesType = ''
  store.crossTopSewing = ''
}

function unsetButtonsData() {
  store.buttonsDistribution = ''
  store.buttonsCols = ''
  store.buttonsRows = ''
  store.buttonsDistanceToEdge = ''
  store.topStitchesType = ''
}
</script>
<template>
  <div class="space-y-6 lg:space-y-10">
    <fieldset class="form-part flex flex-col">
      <legend class="field-name buttons field-label">
        {{ $t('Buttons') }}
      </legend>
      <div class="flex flex-row gap-2">
        <label for="buttons_yes" class="simple-radio">
          <input
            id="buttons_yes"
            class="radio-input"
            type="radio"
            value="buttons_yes"
            name="isButtons"
            v-model="isButtons"
          />
          <span>{{ $t('Yes') }}</span>
        </label>
        <label for="buttons_no" class="simple-radio">
          <input
            id="buttons_no"
            class="radio-input"
            type="radio"
            value="buttons_no"
            name="isButtons"
            v-model="isButtons"
            @click="unsetButtonsData"
          />
          <span>{{ $t('No') }}</span>
        </label>
      </div>
    </fieldset>
    <ButtonsQty />
    <div
      v-if="isButtons === 'buttons_yes'"
      class="flex flex-col items-start bg-black/80 px-6 py-4 text-white w-full max-w-[480px] space-y-4"
    >
      <div class="flex gap-2">
        <IconInfo />
        <p class="w-full">
          {{ $t('Top sewings follows the buttons') }}
        </p>
      </div>
    </div>

    <fieldset class="form-part stitches-part !mt-10">
      <legend class="field-name stitches field-label">
        {{ $t('Stitches') }}
      </legend>
      <div class="stitches-block" :class="{ 'stitches-yes': isStitches === 'stitches_yes' }">
        <div class="form-group">
          <div class="flex flex-row gap-2">
            <label class="simple-radio" for="stitches_yes">
              <input
                name="isStitches"
                v-model="isStitches"
                type="radio"
                class="radio-input"
                value="stitches_yes"
              />

              <span class="check-text">{{ $t('Yes') }}</span>
            </label>
            <label class="simple-radio" for="stitches_no">
              <input
                id="stitches_no"
                name="isStitches"
                v-model="isStitches"
                class="radio-input"
                type="radio"
                value="stitches_no"
                @click="unsetStitchesData"
              />
              <span class="check-text">{{ $t('No') }}</span>
            </label>
          </div>
        </div>
      </div>
    </fieldset>

    <StitchesQty />
    <StitchesType v-if="isStitches === 'stitches_yes' && isButtons === 'buttons_no'" />
    <StitchesTypeSingle v-if="isStitches === 'stitches_yes' && isButtons === 'buttons_yes'" />
  </div>
</template>

<style scoped></style>
